module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "id": _vm.id
    }
  }, [_c('v-style', [_vm._v("//body {overflow: hidden}")]), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    class: {
      flexContainer: _vm.flex
    }
  }, [_c('div', {
    staticClass: "modalBody",
    class: {
      withContent: _vm.withContent, theme: _vm.theme, fixHeight: _vm.fixHeight
    },
    style: ({
      maxWidth: _vm.maxWidthValue,
      minWidth: _vm.minWidthValue
    })
  }, [_c('img', {
    staticClass: "cross fright abs pointer",
    attrs: {
      "src": require("../../assets/croix.png"),
      "width": "40",
      "height": "40",
      "alt": ""
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _vm._t("default")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-168c0362","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalBase.vue
// module id = 3035
// module chunks = 0